export function formatAddress(address) {
  return `${address.line1}, ${address.city}, ${address.region} ${address.postalCode}`;
}
